"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function get() {
    return _Table["default"];
  }
});
Object.defineProperty(exports, "THead", {
  enumerable: true,
  get: function get() {
    return _THead["default"];
  }
});
Object.defineProperty(exports, "TBody", {
  enumerable: true,
  get: function get() {
    return _TBody["default"];
  }
});
Object.defineProperty(exports, "TR", {
  enumerable: true,
  get: function get() {
    return _TR["default"];
  }
});
Object.defineProperty(exports, "TD", {
  enumerable: true,
  get: function get() {
    return _TD["default"];
  }
});
Object.defineProperty(exports, "TH", {
  enumerable: true,
  get: function get() {
    return _TH["default"];
  }
});

var _Table = _interopRequireDefault(require("./js/Table"));

var _THead = _interopRequireDefault(require("./js/THead"));

var _TBody = _interopRequireDefault(require("./js/TBody"));

var _TR = _interopRequireDefault(require("./js/TR"));

var _TD = _interopRequireDefault(require("./js/TD"));

var _TH = _interopRequireDefault(require("./js/TH"));